<mat-tab-group animationDuration="0ms" class="no-scroll">
  <mat-tab>
    <ng-template mat-tab-label>
      <div class="normal-case">Email</div>
    </ng-template>
    <form [formGroup]="emailForm" class="w-full flex flex-col items-stretch place-content-center pt-5">
      <mx-input-form-field fieldName="email" [externalLabel]="true" [uppercaseExternalLabel]="false" placeholder="example@domainname.com"
                           [includeClearButton]="false" [formGroup]="emailForm" overrideLabel="Email Address"
                           overrideBrowserAutocomplete="section-email username"/>

      <mx-password-form-field fieldName="password" [externalLabel]="true" [uppercaseExternalLabel]="false" [includeClearButton]="false"
                              [formGroup]="emailForm" class="no-bottom-margin" overrideBrowserAutocomplete="section-email password"/>

      <div class="flex flex-col gap-y-4">
        <mx-action-buttons>
          <mx-text-button label="forgot password?" (click)="forgotPassword()"/>
        </mx-action-buttons>

        <mx-filled-button type="submit" label="Login" [enabled]="emailForm.valid" (click)="emailLogin()"/>

        <mx-outlined-button label="Create Account" (click)="createAccount()"/>
      </div>
    </form>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <div class="normal-case">Library Card</div>
    </ng-template>
    <form [formGroup]="cardForm" class="w-full flex flex-col items-stretch place-content-center pt-5">
      <mx-input-form-field fieldName="cardNumber" [externalLabel]="true" [uppercaseExternalLabel]="false" placeholder="ex. 1234567890"
                           [includeClearButton]="false" [formGroup]="cardForm" overrideBrowserAutocomplete="section-card username"/>
      <mx-password-form-field fieldName="pin" [externalLabel]="true" [uppercaseExternalLabel]="false" [includeClearButton]="false" [formGroup]="cardForm"
                              overrideBrowserAutocomplete="section-card password"/>

      <div class="flex flex-col gap-y-4">
        <mx-filled-button type="submit" label="Login" [enabled]="cardForm.valid" (click)="cardLogin()"/>

        <mx-outlined-button label="Create Account" (click)="createAccount()"/>
      </div>
    </form>
  </mat-tab>
</mat-tab-group>
